import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Star, User } from 'lucide-react';
import { TaskStatusBadge } from './TaskStatusBadge';
import type { LitLegionTaskWithStatus } from '@/lib/api';

interface TaskCardProps {
  task: LitLegionTaskWithStatus;
}

export function TaskCard({ task }: TaskCardProps) {
  const { task: taskData, taskStatus, npc } = task;
  const description =
    taskData.description && taskData.description.length > 120
      ? `${taskData.description.slice(0, 120)}...`
      : taskData.description;

  return (
    <Link to={`/a/arche_lit_legion/tasks/${taskData.taskId}`} className="block">
      <Card className="h-full hover:border-primary/50 transition-colors">
        <CardHeader className="pb-2">
          <div className="flex items-start justify-between gap-2">
            <CardTitle className="text-base line-clamp-1">{taskData.name}</CardTitle>
            <TaskStatusBadge status={taskStatus?.status} />
          </div>
        </CardHeader>
        <CardContent className="space-y-2">
          {description && (
            <p className="text-sm text-muted-foreground line-clamp-2">{description}</p>
          )}
          <div className="flex items-center flex-wrap gap-2">
            {taskData.category && (
              <Badge variant="outline" className="text-xs">
                {taskData.category}
              </Badge>
            )}
            {taskData.taskType && (
              <Badge variant="secondary" className="text-xs">
                {taskData.taskType}
              </Badge>
            )}
          </div>
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <Star className="h-3.5 w-3.5 text-yellow-500" />
              <span>{taskData.xpReward} XP</span>
            </div>
            {npc && (
              <div className="flex items-center gap-1">
                <User className="h-3.5 w-3.5" />
                <span className="truncate max-w-[120px]">{npc.name}</span>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
